module.exports = __webpack_public_path__ + "static/media/pulverizador2.d0a3a64a.svg";